import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
// Consider replacing these images with ones relevant to NICU/Newborn Care if available
import nicuBg1 from './NICU.png'; // Kept original paths, rename/replace images as needed
import nicuBg2 from '../../assets/img/clinic//2.png'; // Kept original paths, rename/replace images as needed
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const NICU = () => { // Changed component name
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    // Use the imported images - update these if you have NICU-specific visuals
    const images = [nicuBg1]; // Used renamed variables for clarity
     const backgroundImage = images[currentImageIndex];

    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

         

            <div className="content">
              {/* Full-Width Background with Minimal Text - Kept urology-header class as requested */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                    <p>
                                       <br />
                                         {/* Updated Header Text */}
                                         <strong>NICU at Hitkari Hospital: Specialized Care for Newborns</strong>
                                          </p>

                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">

                             <div className="terms-content">
                                <div className="terms-text">
                                     {/* Updated Content: Introduction */}
                                     <h3>Neonatal Intensive Care Unit (NICU) at Hitkari Hospital</h3>
                                       <p>The Neonatal Intensive Care Unit (NICU) at Hitkari Hospital provides highly specialized, compassionate care for premature infants and critically ill newborns. Our state-of-the-art facility is designed to meet the unique needs of these vulnerable babies, offering advanced medical technology and a dedicated team of neonatal specialists. We understand the challenges families face when a newborn requires intensive care, and we are committed to providing comprehensive support in a nurturing environment.</p>
                                </div>
                                <div className="terms-text">
                                    {/* Updated Content: Who We Care For */}
                                    <h3>Who Needs NICU Care?</h3>
                                    <h4>Our NICU team provides expert care for newborns facing various challenges, including:</h4>
                                    <ul>
                                        <li>Prematurity: Infants born significantly before their due date (typically before 37 weeks gestation).</li>
                                        <li>Low Birth Weight: Babies born weighing less than 2.5 kg (5.5 lbs), especially very low birth weight (VLBW) and extremely low birth weight (ELBW) infants.</li>
                                        <li>Respiratory Distress Syndrome (RDS): Difficulty breathing common in premature infants due to underdeveloped lungs.</li>
                                        <li>Congenital Anomalies: Birth defects requiring specialized medical or surgical intervention.</li>
                                        <li>Neonatal Infections: Serious infections like sepsis or pneumonia requiring intensive treatment.</li>
                                        <li>Birth Asphyxia: Complications during birth leading to oxygen deprivation.</li>
                                        <li>Other Critical Conditions: Including jaundice requiring phototherapy, feeding difficulties, or recovery after complex deliveries.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                       {/* Updated Content: Services & Technology */}
                                       <h4>Key Services and Technologies in Our NICU</h4>
                                        <ul>
                                            <li>Advanced Respiratory Support: Including conventional ventilators, CPAP (Continuous Positive Airway Pressure), and high-flow nasal cannula oxygen therapy.</li>
                                            <li>Incubators and Radiant Warmers: Providing controlled temperature and humidity environments crucial for premature infant stability.</li>
                                            <li>Continuous Monitoring: State-of-the-art systems tracking vital signs like heart rate, respiratory rate, oxygen saturation, and blood pressure 24/7.</li>
                                            <li>Specialized Feeding Support: Including intravenous (IV) nutrition (TPN), nasogastric (NG) or orogastric (OG) tube feeding, and expert lactation support for breastfeeding mothers.</li>
                                            <li>Phototherapy: Treatment for neonatal jaundice using specialized lights.</li>
                                            <li>Diagnostic Capabilities: Access to bedside X-rays, ultrasounds, and laboratory services for rapid assessment.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                      {/* Updated Content: Medical Team */}
                                      <h4>Our Dedicated NICU Team</h4>
                                      <ul>
                                            <li>Neonatologists: Pediatricians with specialized training in the care of sick and premature newborns, leading the medical management.</li>
                                            <li>NICU Nurses: Highly skilled nurses with specific expertise in neonatal intensive care, providing round-the-clock monitoring and hands-on care.</li>
                                            <li>Respiratory Therapists: Specialists managing ventilation equipment and respiratory treatments.</li>
                                            <li>Lactation Consultants: Providing support and guidance for breastfeeding and expressing milk for NICU babies.</li>
                                            <li>Collaboration with Specialists: Access to pediatric surgeons, cardiologists, neurologists, and other specialists as needed.</li>
                                        </ul>
                                 </div>
                                   <div className="terms-text">
                                       {/* Updated Content: Family-Centered Care */}
                                       <h4>Family-Centered Care Approach</h4>
                                        <ul>
                                            <li>Parental Involvement: Encouraging parents to participate actively in their baby's care, including kangaroo care (skin-to-skin contact).</li>
                                            <li>Communication and Support: Regular updates from the medical team and emotional support for families during a stressful time.</li>
                                            <li>Education: Providing parents with information about their baby's condition and the care they are receiving.</li>
                                            <li>Transition Planning: Preparing families for discharge and ensuring they are confident in caring for their baby at home, including necessary follow-up appointments.</li>
                                        </ul>
                                </div>
                                 {/* Removed the 6th section to keep similar structure (5 specific + intro + conclusion) */}
                                  <div className="terms-text">
                                      {/* Updated Content: Why Choose */}
                                    <h3>Why Choose the NICU at Hitkari Hospital?</h3>
                                      <ul>
                                           <li>Specialized Neonatal Expertise: Led by experienced neonatologists and staffed by dedicated NICU nurses and therapists.</li>
                                           <li>Advanced Technology: Equipped with modern incubators, ventilators, and monitoring systems essential for critical neonatal care.</li>
                                            <li>Comprehensive Care: Managing a wide range of conditions affecting premature and ill newborns.</li>
                                            <li>Family-Oriented Environment: Recognizing the importance of family presence and involvement in the healing process.</li>
                                           <li>Focus on Safety and Development: Prioritizing infection control, gentle handling, and developmentally appropriate care practices.</li>
                                           <li>Integrated Hospital Support: Seamless access to laboratory, radiology, and other pediatric specialty services within Hitkari Hospital.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    {/* Updated Content: Conclusion */}
                                    <p>At Hitkari Hospital's Neonatal Intensive Care Unit (NICU), we provide a lifeline for our smallest and most vulnerable patients. Our commitment is to deliver the highest standard of medical care combined with compassion and support, helping premature and critically ill newborns thrive and giving families hope during challenging times.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default NICU; // Make sure to export the correct component name